import _omitBy from 'lodash/omitBy';
import _isUndefined from 'lodash/isUndefined';
import { post, put, del, get } from '../../../utils/api';
import { plainPhoneNumber } from '../../../utils/telephone';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  hasPhone: phone =>
    get({
      url: 'user/has-phone',
      data: { phone: phone.replace(/[^0-9]/gi, '') },
    }),
  hasMail: email =>
    get({
      url: 'user/has-email',
      data: { email },
    }),
  signUp: params =>
    put({
      url: 'user/signup',
      data: { ...params, phone: plainPhoneNumber(params.phone) },
    }),
  signIn: ({ phone, password }) =>
    post({
      url: 'user/login',
      data: withUnauthorizedToken({ password, phone: plainPhoneNumber(phone), withError: false }),
    }),
  delAccount: () => del({ url: 'user/delete' }),
  signOut: () => del({ url: 'user/logout' }),
  sendConfirmCode: ({ phone, ...otherParams }) =>
    post({
      url: 'user/confirm-code',
      data: _omitBy(
        {
          ...otherParams,
          phone: phone ? plainPhoneNumber(phone) : undefined,
        },
        _isUndefined,
      ),
    }),
  recoveryPassword: ({ phone, ...otherParams }) =>
    post({
      url: 'user/recovery-password',
      data: _omitBy(
        {
          ...otherParams,
          phone: phone ? plainPhoneNumber(phone) : undefined,
        },
        _isUndefined,
      ),
    }),
  getProfile: params => get({ url: 'user/read', data: params }),
  updateProfile: params =>
    post({
      url: 'user/update',
      data: params,
    }),
  setAvatar: params =>
    post({
      url: 'user/update',
      type: 'form-data',
      data: params,
    }),
};
